"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validate = void 0;
const seriallyPromise_1 = require("./seriallyPromise");
const parallelPromise_1 = require("./parallelPromise");
const namedErrorContainer_1 = require("./namedErrorContainer");
/**
 * Validates collection of values respectively to validation rules.
 * Input rules validates serially.
 * Collection of inputs validates in parallel.
 * */
function validate(values, rules) {
    const formValidationPromises = Object.keys(values).reduce((memo, valuesKey) => {
        const rulesList = rules[valuesKey] || [];
        const promiseFunctions = rulesList.map((rule) => (0, namedErrorContainer_1.namedErrorContainer)(valuesKey, () => rule(values[valuesKey], values)));
        // validate each input (couple of rules, serially)
        const inputValidationPromises = (0, seriallyPromise_1.seriallyPromise)(promiseFunctions);
        return [...memo, inputValidationPromises];
    }, []);
    // Async validate all inputs (couple of rules, parallel).
    // Shouldn't fail when one promise is rejected. Gather rejection errors instead
    return (0, parallelPromise_1.parallelPromise)(formValidationPromises);
}
exports.validate = validate;
//# sourceMappingURL=validate.js.map